/* kitsters-kwikpass.js - Kwikpass cart-click handler (global function called from HTML onclick) */
function kpcartClick() {
  var dialog = document.querySelector('#menu_mobile');
  if (dialog && dialog.hasAttribute('open')) {
    if (dialog.close) dialog.close();
    setTimeout(function () {
      kpHandleLogin('/account');
    }, 500);
  } else {
    handleKpAndShopifyLogin(window.location.href);
  }
}
